import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const contentContainerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;

  ${MEDIA_MIN_SM} {
    flex-direction: row;
    align-items: center;
  }
`;

export const tagsContainerStyles = css`
  display: flex;
  row-gap: var(${SpacingToken.Spacing2});
  flex-wrap: wrap;
  max-width: 184px;
  margin-bottom: var(${SpacingToken.Spacing4});

  ${MEDIA_MIN_SM} {
    max-width: fit-content;
    margin-bottom: 0;
  }
`;

export const externalAppTagStyles = css`
  border: 1px solid var(${DesignToken.BorderBasicPrimary});
  height: 24px;
  margin-right: var(${SpacingToken.Spacing2});

  > div > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 var(${SpacingToken.Spacing2});
    margin: 0;
  }
`;

export const tagTextStyles = css`
  margin: 0 0 0 var(${SpacingToken.Spacing1});
`;

export const noProductsStyles = css`
  color: var(${DesignToken.ContentBasicPrimary});
  text-align: left;
`;
